<nav aria-label="breadcrumb">
	<ol class="breadcrumb mb-0 pl-0">
		<li class="breadcrumb-item"><a [href]="'/reemplazo-docente-inicio'">Reemplazo docente</a></li>
		<li class="breadcrumb-item active" aria-current="page"><a><strong>Editar</strong></a></li>
	</ol>
</nav>
<div class="row">
	<button class="boton_volver" (click)="navToInicioReemplazoDocente()" data-toggle="tooltip" data-placement="top" title="VOLVER" alt="VOLVER"><i class="bi bi-chevron-left mr-2"></i>Volver</button>
	<h1 class="centrar_contenido offset-3">Editar reemplazo docente</h1>
</div>

<!-- DETALLE CONFIGURACIÓN -->
<div class="row mt-5 align-items-center">
	<div class="hr-amarillo mr-3"></div>
	<h6 class="mb-0">Docente a reemplazar</h6>
</div>

<div class="row mt-5 align-items-end">
    <div class="col-1">
        <label class="titulo_criterios" for="exampleFormControlSelect2">Año</label>
        <div class="input-group mb-0">
            <input type="text" class="form-control select_criterios" disabled  [(ngModel)]="reemplazo.anoAcademico"
                >
        </div>
    </div>
    <div class="col-2">
        <label class="titulo_criterios" for="exampleFormControlSelect2">Periodo</label>
        <div class="input-group mb-0">
            <input type="text" class="form-control select_criterios" disabled [(ngModel)]="reemplazo.periodoDesc"
                >
        </div>
    </div>
    <div class="col-2">
        <label class="titulo_criterios" for="exampleFormControlSelect2">Sede</label>
        <div class="input-group mb-0">
            <input type="text" class="form-control select_criterios" disabled [(ngModel)]="reemplazo.sede"
                >
        </div>
    </div>
    <div class="col-2">
        <label class="titulo_criterios" for="exampleFormControlSelect2">ID Sección</label>
        <div class="input-group mb-0">
            <input type="text" class="form-control select_criterios" disabled [(ngModel)]="reemplazo.idSeccion"
                >
        </div>
    </div>
    <div class="col-2">
        <label class="titulo_criterios" for="exampleFormControlSelect2">ID Docente</label>
        <div class="input-group mb-0">
            <input type="text" class="form-control select_criterios" disabled [(ngModel)]="reemplazo.codigoDocente"
                >
        </div>
    </div>
    <div class="col-3">
        <label class="titulo_criterios" for="exampleFormControlSelect2">Nombre Docente</label>
        <div class="input-group mb-0">
            <input type="text" class="form-control select_criterios" disabled [(ngModel)]="reemplazo.nombreDocente"
                >
        </div>
    </div>
</div>
<div style="margin-top: 20px;">
	<table datatable [dtOptions]="dtOptions" class="row-border hover table-striped display nowrap " aria-describedby="tabla reemplazo docente">
		<thead class="header_tabla">
			<tr>
				<th class="py-2">Sede</th>
				<th class="py-2">Sigla</th>
				<th class="py-2">Asignatura</th>
				<th class="py-2">ID Sección</th>
				<th class="py-2">Sección</th>
				<th class="py-2">Jornada</th>
				<th class="py-2">Modalidad</th>
			</tr>
		</thead>
		<tbody style="height: 45px;">
			<tr>
				<td class="py-0">{{ reemplazo.sede }}</td>
				<td class="py-0">{{ reemplazo.codigoAsignatura }}</td>
				<td class="py-0">{{ reemplazo.descAsignatura }}</td>
				<td class="py-0">{{ reemplazo.idSeccion }}</td>
				<td class="py-0">{{ reemplazo.seccion }}</td>
				<td class="py-0">{{ reemplazo.codigoJornada }}</td>
				<td class="py-0">{{ reemplazo.descMetodoFormacion }}</td>
			</tr> 
		</tbody>
	</table>
</div>

<div class="row mt-5 align-items-center">
	<div class="hr-amarillo mr-3"></div>
	<h6 class="mb-0">Docente reemplazante</h6>
</div>

<div class="row mt-5 align-items-end">
	<div class="col-3">
		<form class="form" [formGroup]="reemplazoDocenteForm">
			<label class="titulo_criterios" for="exampleFormControlSelect2">ID Docente</label>
			<div class="input-group">
				<mat-autocomplete #autoDocentesReemplazo="matAutocomplete" [displayWith]="displayFnCodDocentesReemplazo">
					<mat-option *ngFor="let docente of filteredCodDocentesReemplazo | async" [value]="docente">
							{{docente?.codigo}}
					</mat-option>
				</mat-autocomplete>
				<input type="text" (ngModelChange)="resetearValidacion()" (keypress)="keypressNumber($event)" id="inputCodDocenteReemplazo" [formControl]="searchCodDocenteReemplazoForm" formControlName="idDocenteReemplazo" [matAutocomplete]="autoDocentesReemplazo" class="form-control select_criterios" placeholder="" [ngClass]="{ 'is-invalid': submitted && tieneErrores['idDocenteReemplazo'] }">
				<div *ngIf="submitted && tieneErrores['idDocenteReemplazo']" class="invalid-feedback">
					<div *ngIf="tieneErrores['idDocenteReemplazo']" class="position-absolute">Campo requerido</div>
				</div>
			</div>
		</form>
	</div>
	<div class="col-1 centrar_iconos_botones">
		<button (click)="buscarDocenteReemplazo()" class="boton-buscar" data-toggle="tooltip" data-placement="top" title="BUSCAR" alt="BUSCAR"><i class="bi bi-search"></i></button>
	</div>
	<div class="col-1 centrar_iconos_botones">
		<button (click)="limpiarFiltrosDocenteReemplazo()" class="boton-secundario tamanio_iconos-boton" data-toggle="tooltip" data-placement="top" title="ELIMINAR" alt="ELIMINAR"><i class="bi bi-x"></i></button>
	</div>
</div>

<div class="row mt-5">
	<div class="col-3">
		<label class="titulo_criterios" for="exampleFormControlSelect2">Nombre docente</label>
		<div class="input-group mb-0">
			<label class="docente_reemplazante">{{ nombreDocenteReemplazo }}</label>
		</div>
	</div>
	<div class="col-3">
		<label class="titulo_criterios" for="exampleFormControlSelect2">Fecha inicio</label>
		<div class="input-group mb-0">
			<input type="date" (change)="resetearValidacion()" [(ngModel)]="fechaInicioDocenteReemplazo" class="form-control select_criterios" placeholder="11/11/2023" aria-describedby="basic-addon2" [ngClass]="{ 'is-invalid': submitted && tieneErrores['fechaInicioDocenteReemplazo'] }" [disabled]="fechaDisabled">
			<div *ngIf="submitted && tieneErrores['fechaInicioDocenteReemplazo']" class="invalid-feedback">
				<div *ngIf="tieneErrores['fechaInicioDocenteReemplazo']" class="position-absolute">Campo requerido</div>
			</div>
		</div>
	</div>
	<div class="col-3">
		<label class="titulo_criterios" for="exampleFormControlSelect2">Fecha término</label>
		<div class="input-group mb-0">
			<input type="date" (change)="resetearValidacion()" [(ngModel)]="fechaFinDocenteReemplazo" class="form-control select_criterios" placeholder="11/11/2023" aria-describedby="basic-addon2" [ngClass]="{ 'is-invalid': submitted && tieneErrores['fechaFinDocenteReeemplazo'] }">
			<div *ngIf="submitted && tieneErrores['fechaFinDocenteReeemplazo']" class="invalid-feedback">
				<div *ngIf="tieneErrores['fechaFinDocenteReeemplazo']" class="position-absolute">Campo requerido</div>
			</div>
		</div>
	</div>
</div>
<!-- FIN DETALLE CONFIGURACIÓN -->
<div class="mb-5 mt-5 pb-5">
	<button (click)="navToInicioReemplazoDocente()" class="boton-secundario offset-4" data-toggle="tooltip" data-placement="top" title="CANCELAR" alt="CANCELAR">cancelar</button>
	<button (click)="editarReemplazoDocente()" class="boton-primario ml-3 my-5" data-toggle="tooltip" data-placement="top" title="GUARDAR CAMBIOS" alt="GUARDAR CAMBIOS">Guardar Cambios</button>
</div>

<app-modal-info modalId="modal-info" [titulo]="infoModalTitulo" [texto]="infoModalTexto"></app-modal-info>
<button id="btn-modal-info" type="button" class="btn btn-primary d-none" data-toggle="modal" data-target="#modal-info">
  Launch demo modal
</button>